import React, {useEffect, useState} from "react"
import {FormattedMessage, injectIntl} from "react-intl";
import Navbar from "./component/navbar";
import {getAssetRefreshInterval, getNodeId} from "../../../util/Util";
import BinTesterPage from "./view/bin-tester-page";
import AisleTester from "./view/aisle-tester-page";
import ControllerTesterPage from "./view/controller-tester-page";
import {loadSiteConfig} from "./config";
import LoaderView from "../../../loader/Loader";
import Alert from "@amzn/meridian/alert";

const BinTester = ({intl}) => {

    const [siteId, setSiteId] = useState(getNodeId());
    const [siteConfig, setSiteConfig] = useState({});
    const [binShowFlag, setBinShowFlag] = useState(true);
    const [controllerShowFlag, setControllerShowFlag] = useState(false);
    const [clusterShowFlag, setClusterShowFlag] = useState(false);

    useEffect(() => {
        getData();
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getAssetRefreshInterval());
        return () => clearInterval(interval);
    }, [siteId]);

    const updateSiteConfig = (siteConfig) => {
        setSiteConfig(siteConfig);
    }

    const updateSiteId = (siteId) => {
        setSiteId(siteId);
    }

    const getData = async () => {
        const siteConfig = await loadSiteConfig();
        setSiteConfig(siteConfig);
    }

    const onNavChange = (type) => {
        if(type === "bin") {
            setBinShowFlag(true);
            setClusterShowFlag(false);
            setControllerShowFlag(false);
        } else if(type === 'cluster') {
            setBinShowFlag(false);
            setClusterShowFlag(true);
            setControllerShowFlag(false);
        } else if(type === 'controller') {
            setBinShowFlag(false);
            setClusterShowFlag(false);
            setControllerShowFlag(true);
        }
    }

    if (!siteConfig.data) {
        if(siteConfig.status && siteConfig.status !== 200) {
            return <Alert
                type="informational"
                size="small">
                <FormattedMessage id="bintester.errorMessage"
                                  defaultMessage="An error occurred while fetching the site config for this station"/>
            </Alert>
        } else {
            return (<LoaderView/>)
        }
    } else {
        return (
            <div>
                <div>
                    <Navbar
                        siteId={siteId}
                        siteConfig={siteConfig}
                        onSiteIdChange={updateSiteId}
                        onSiteConfigChange={updateSiteConfig}
                        onNavChange={onNavChange}
                    />
                </div>

                {controllerShowFlag && <ControllerTesterPage
                    siteId={siteId}
                    siteConfig={siteConfig}
                />}

                {binShowFlag && (<BinTesterPage
                    siteId={siteId}
                    siteConfig={siteConfig}
                />)}

                {clusterShowFlag && <AisleTester
                    siteId={siteId}
                    siteConfig={siteConfig}
                />}
            </div>
        );
    }
}

export default injectIntl(BinTester);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/index.js